export function buildWhatsAppUrl({ phoneNumber, message }) {
  const digitsOnly = String(phoneNumber || '').replace(/[^\d]/g, '');
  const safeMessage = encodeURIComponent(message || '');
  return `https://wa.me/${digitsOnly}?text=${safeMessage}`;
}

